import MyFiancesPage from "components/pages/MyFinancesPage";
import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

export default function CaptureQuickTourPersonalFinance(props) {
    const context = useBCMSContext();
    const { branding } = context.state;
    const { options } = branding ?? {};
    BCMSRecord.globalControllerFor(Classes, context);
    const hasMyFinances = options.pfm21_abi22 === "true";

    if(!hasMyFinances) {
        const message = `This capture is only shown when "*My Finances" is set to "Yes".`;
        return <CaptureNotShownView message={ message }/>;
    }

    return <MyFiancesPage />
}